import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import { getSizeVerbose } from '../../config/constants-sizes';
import Button from '../Button';
import CheckBox from '../CheckBox';
import css from './FiltersMobile.module.scss';
import Image from '../Image';
import toGlobalID from '../../utils/toGlobalID';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CheckListPalette = function CheckListPalette(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      query = _ref.query,
      variables = _ref.variables,
      value = _ref.value;

  var _useQuery = useQuery({
    query: query,
    variables: variables
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (fetching || error) {
    return false;
  }

  var options = data ? data.options.edges.map(function (_ref2) {
    var node = _ref2.node;
    return node;
  }) : [];
  return /*#__PURE__*/_jsx("div", {
    className: css.options,
    children: options.map(function (option) {
      var id = toGlobalID(option.id);
      return /*#__PURE__*/_jsx("div", {
        className: cc([css.option, css.marginal]),
        children: /*#__PURE__*/_jsx(Button, {
          "aria-label": "Click to filter by ".concat(option.title),
          className: cc([css.img, _defineProperty({}, css.on, id === parseInt(value, 10))]),
          linkStyle: true,
          onClick: function onClick() {
            onChange({
              target: {
                name: label,
                value: id,
                label: label
              }
            });
          },
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, option.image), {}, {
            alt: "".concat(option.title, " image"),
            sizes: [24]
          }))
        })
      }, "".concat(label, "-").concat(id));
    })
  });
};
CheckListPalette.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  variables: PropTypes.shape().isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var CheckList = function CheckList(_ref4) {
  var label = _ref4.label,
      onChange = _ref4.onChange,
      options = _ref4.options,
      value = _ref4.value;
  return /*#__PURE__*/_jsx("div", {
    className: css.options,
    children: options.map(function (option) {
      var optionLabel = getSizeVerbose(option.labelString || option.label).toLowerCase();
      return /*#__PURE__*/_jsx("div", {
        className: css.option,
        children: /*#__PURE__*/_jsx(CheckBox, _objectSpread(_objectSpread({}, option), {}, {
          ariaLabel: "Filter by ".concat(optionLabel),
          name: option.labelString || "".concat(label, "-").concat(option.label),
          onChange: onChange,
          checked: option.value === value
        }))
      }, option.labelString || "".concat(label, "-").concat(option.label));
    })
  });
};

CheckList.defaultProps = {
  value: ''
};
CheckList.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var FiltersMobile = function FiltersMobile(_ref5) {
  var filters = _ref5.filters,
      filterSelect = _ref5.filterSelect,
      on = _ref5.on;
  return /*#__PURE__*/_jsx("ul", {
    className: cc([css.list, _defineProperty({}, css.on, on)]),
    children: filters.map(function (filter) {
      var Component = filter.componentMobile ? filter.componentMobile : CheckList;
      return /*#__PURE__*/_jsxs("li", {
        className: css.item,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: filter.label
        }), /*#__PURE__*/_jsx(Component, {
          label: filter.label,
          placeholder: filter.label,
          query: filter.query,
          onChange: function onChange(_ref7) {
            var target = _ref7.target;
            filterSelect(filter, target);
          },
          name: filter.label,
          options: filter.options,
          variables: filter.variables,
          value: filter.selected ? filter.selected.value : ''
        })]
      }, filter.label);
    })
  });
};

FiltersMobile.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  filterSelect: PropTypes.func.isRequired,
  on: PropTypes.bool.isRequired
};
export default FiltersMobile;